module.exports = __webpack_public_path__ + "img/0-02-0a-0342e606ae5dcd85c1fe5218b1cc46de3203dd426b27604e27f527c27558015c_c8b7643b.f9bc6930.jpg";